// extracted by mini-css-extract-plugin
module.exports = {"splitEvenly":"columns-module--splitEvenly--CXP_V"};